import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

type BreadcrumbItem = {name: string, url: string} | string;

@Component({
    selector: 'breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: false
})
export class BreadcrumbComponent implements OnInit {
  routeMap: Map<string, BreadcrumbItem[]> = new Map([
    ["CustomerManagementPageComponent",["Customer Management", "Customer List"]],
    ["CustomerAddPageComponent",["Customer Management", { name: "Customer List", url: "home/customer-management/list" }, "New Customer"]],
    ["CustomerEditPageComponent",["Customer Management", { name: "Customer List", url: "home/customer-management/list" }, "Edit Customer"]]
  ]);

  currentTrail: BreadcrumbItem[] = [];

  constructor(private readonly router: Router, private readonly activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.currentTrail = this.routeMap.get(this.activatedRoute.component.name) ?? [];
  }

  getUrl(item: BreadcrumbItem){
    if(typeof item === "string"){
      return null;
    }

    const itemObj = item as any;
    return itemObj.url;
  }

  getName(item: BreadcrumbItem){
    if(typeof item === "string"){
      return item;
    }

    const itemObj = item as any;
    return itemObj.name;
  }

  navigate(item){
    const url = this.getUrl(item);

    if(url){
      this.router.navigateByUrl(url);
    }
  }

  isLastItem(item: BreadcrumbItem){
    return this.currentTrail.indexOf(item) === this.currentTrail.length - 1;
  }

}
